import { CategoryData } from '../../../../types/types';

export const temps: CategoryData = {
    // Jours
    'Lelo (Aujourd\'hui)': {
        translation: 'Aujourd\'hui',
        translationEn: 'Today',
        illustration: '📅',
        audio: 'Li-lelo'
    },
    'Lobi (Demain)': {
        translation: 'Demain',
        translationEn: 'Tomorrow',
        illustration: '🌅',
        audio: 'Li-lobi'
    },
    'Lobi eleki (Hier)': {
        translation: 'Hier',
        translationEn: 'Yesterday',
        illustration: '🌙',
        audio: 'Li-lobi_eleki'
    },
    'Sima ya lobi (Après-demain)': {
        translation: 'Après-demain',
        translationEn: 'The day after tomorrow',
        illustration: '📆',
        audio: 'Li-sima_ya_lobi'
    },
    'Lobi mibale eleki (Avant-hier)': {
        translation: 'Avant-hier',
        translationEn: 'The day before yesterday',
        illustration: '📅',
        audio: 'Li-lobi_mibale_eleki'
    },

    // Moments de la journée
    'Ntongo (Matin)': {
        translation: 'Matin',
        translationEn: 'Morning',
        illustration: '🌄',
        audio: 'Li-ntongo'
    },
    'Moyi (Jour/Soleil)': {
        translation: 'Jour/Soleil',
        translationEn: 'Day/Sun',
        illustration: '☀️',
        audio: 'Li-moyi'
    },
    'Mpokwa (Soir)': {
        translation: 'Soir',
        translationEn: 'Evening',
        illustration: '🌆',
        audio: 'Li-mpokwa'
    },
    'Butu (Nuit)': {
        translation: 'Nuit',
        translationEn: 'Night',
        illustration: '🌙',
        audio: 'Li-butu'
    },

    // Périodes
    'Sanza (Mois/Lune)': {
        translation: 'Mois/Lune',
        translationEn: 'Month/Moon',
        illustration: '🌕',
        audio: 'Li-sanza'
    },
    'Mbula (Année)': {
        translation: 'Année',
        translationEn: 'Year',
        illustration: '📅',
        audio: 'Li-mbula'
    },
    'Poso (Semaine)': {
        translation: 'Semaine',
        translationEn: 'Week',
        illustration: '📅',
        audio: 'Li-poso'
    },
      'Tango(Temps/Quand)': {
        translation: 'Temps',
        translationEn: 'Time',
        illustration: '📅',
        audio: 'Li-tango'
    },

    // Jours de la semaine
    'Mokolo ya yambo (Lundi)': {
        translation: 'Lundi',
        translationEn: 'Monday',
        illustration: '1️⃣',
        audio: 'Li-mokolo_ya_yambo'
    },
    'Mokolo ya mibale (Mardi)': {
        translation: 'Mardi',
        translationEn: 'Tuesday',
        illustration: '2️⃣',
        audio: 'Li-mokolo_ya_mibale'
    },
    'Mokolo ya misato (Mercredi)': {
        translation: 'Mercredi',
        translationEn: 'Wednesday',
        illustration: '3️⃣',
        audio: 'Li-mokolo_ya_misato'
    },
    'Mokolo ya minei (Jeudi)': {
        translation: 'Jeudi',
        translationEn: 'Thursday',
        illustration: '4️⃣',
        audio: 'Li-mokolo_ya_minei'
    },
    'Mokolo ya mitano (Vendredi)': {
        translation: 'Vendredi',
        translationEn: 'Friday',
        illustration: '5️⃣',
        audio: 'Li-mokolo_ya_mitano'
    },
    'Mposo (Samedi)': {
        translation: 'Samedi',
        translationEn: 'Saturday',
        illustration: '6️⃣',
        audio: 'Li-mposo'
    },
    'Eyenga (Dimanche)': {
        translation: 'Dimanche',
        translationEn: 'Sunday',
        illustration: '7️⃣',
        audio: 'Li-eyenga'
    },

    // Précisions temporelles
    'Kala (Il y a longtemps)': {
        translation: 'Il y a longtemps',
        translationEn: 'A long time ago',
        illustration: '⌛',
        audio: 'Li-kala'
    },
    'Sika (Maintenant/Nouveau)': {
        translation: 'Maintenant/Nouveau',
        translationEn: 'Now/New',
        illustration: '⚡',
        audio: 'Li-sika'
    },
    'Na sima (Plus tard/Après)': {
        translation: 'Plus tard/Après',
        translationEn: 'Later/After',
        illustration: '➡️',
        audio: 'Li-na_sima'
    },
    'Liboso (Avant/Devant)': {
        translation: 'Avant/Devant',
        translationEn: 'Before/In front',
        illustration: '⬅️',
        audio: 'Li-liboso'
    },
      'Wapi (où)': {
        translation: 'Où',
        translationEn: 'Where',
        illustration: '⬅️',
        audio: 'Li-wapi'
    },
     'Pembeni (Près de)': {
        translation: 'Près de',
        translationEn: 'Near',
        illustration: '⬅️',
        audio: 'Li-pembeni'
    },
    'Mopenzi (à coté)': {
        translation: 'A coté',
        translationEn: 'Next to',
        illustration: '⬅️',
        audio: 'Li-mopenzi'
    },
     'Kuna (La-bas)': {
        translation: 'Là bas',
        translationEn: 'Over there',
        illustration: '⬅️',
        audio: 'Li-kuna'
    },
     'Tango nionso (longtemps)': {
        translation: 'Longtemps',
        translationEn: 'A long time',
        illustration: '⬅️',
        audio: 'Li-tango_nionso'
    },
    'Seko (éternellement)': {
        translation: 'Eternellement',
        translationEn: 'Forever',
        illustration: '⬅️',
        audio: 'Li-seko'
    },
    'Tango iso (éternellement)': {
        translation: 'Eternellement',
        translationEn: 'Forever',
        illustration: '⬅️',
        audio: 'Li-tango iso'
    },
       'Nzela (chemin)': {
        translation: 'Chemin',
        translationEn: 'Path/Way',
        illustration: '⬅️',
        audio: 'Li-nzela'
    },


    // Saisons
    'Eleko ya mvula (Saison des pluies)': {
        translation: 'Saison des pluies',
        translationEn: 'Rainy season',
        illustration: '🌧️',
        audio: 'Li-eleko_ya_mvula'
    },
    'Eleko ya kokauka (Saison sèche)': {
        translation: 'Saison sèche',
        translationEn: 'Dry season',
        illustration: '☀️',
        audio: 'Li-eleko_ya_kokauka'
    },

    // Expressions temporelles
    'Mbala na mbala (Souvent/Plusieurs fois)': {
        translation: 'Souvent/Plusieurs fois',
        translationEn: 'Often/Several times',
        illustration: '🔄',
        audio: 'Li-mbala_na_mbala'
    },
    'Mokolo na mokolo (Tous les jours)': {
        translation: 'Tous les jours',
        translationEn: 'Every day',
        illustration: '📆',
        audio: 'Li-mokolo_na_mokolo'
    },
    'Na ntongo nyonso (Chaque matin)': {
        translation: 'Chaque matin',
        translationEn: 'Every morning',
        illustration: '🌅',
        audio: 'Li-na_ntongo_nyonso'
    },
    'Na mpokwa nyonso (Chaque soir)': {
        translation: 'Chaque soir',
        translationEn: 'Every evening',
        illustration: '🌆',
        audio: 'Li-na_mpokwa_nyonso'
    },

    // Durées
    'Mwa moke (Un peu de temps/Un moment)': {
        translation: 'Un peu de temps/Un moment',
        translationEn: 'A little time/A moment',
        illustration: '⏱️',
        audio: 'Li-mwa_moke'
    },
    'Ngonga mobimba (Une heure entière)': {
        translation: 'Une heure entière',
        translationEn: 'A whole hour',
        illustration: '🕐',
        audio: 'Li-ngonga_mobimba'
    },
    'Mokolo mobimba (Toute la journée)': {
        translation: 'Toute la journée',
        translationEn: 'All day long',
        illustration: '☀️',
        audio: 'Li-mokolo_mobimba'
    },
    'Butu mobimba (Toute la nuit)': {
        translation: 'Toute la nuit',
        translationEn: 'All night long',
        illustration: '🌙',
        audio: 'Li-butu_mobimba'
    },

    // Moments précis
    'Na ngonga ya midi (À midi)': {
        translation: 'À midi',
        translationEn: 'At noon',
        illustration: '🕛',
        audio: 'Li-na_ngonga_ya_midi'
    },
    'Na katikati ya butu (À minuit)': {
        translation: 'À minuit',
        translationEn: 'At midnight',
        illustration: '🕛',
        audio: 'Li-na_katikati_ya_butu'
    },
    'Na ntongo-ntongo (Très tôt le matin)': {
        translation: 'Très tôt le matin',
        translationEn: 'Very early in the morning',
        illustration: '🌅',
        audio: 'Li-na_ntongo_ntongo'
    }
};

export default temps;
